export default "__VITE_ASSET__Bz05WMcj__"